import { render, staticRenderFns } from "./return-orders.vue?vue&type=template&id=0c5fb10d&lang=pug"
import script from "./return-orders.vue?vue&type=script&lang=js"
export * from "./return-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports